module.exports = __webpack_public_path__ + "img/bg_m.89a48a6f.jpg";